import { render, staticRenderFns } from "./CoinDialogComponent.vue?vue&type=template&id=ca12d5d0&scoped=true"
import script from "./CoinDialogComponent.vue?vue&type=script&lang=js"
export * from "./CoinDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca12d5d0",
  null
  
)

export default component.exports